
<style scoped lang="scss">
@import '~@/assets/styles/vars';

// https://stackoverflow.com/questions/826782/how-to-disable-text-selection-highlighting
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
.input-range_wrapper {
  font-family: $ff_basic;

  .mod-button {
    @extend .noselect;
    $size: 24px;

    display: inline-block;
    text-align: center;
    width: $size;
    height: $size;
    // line-height: $size;
    // font-size: 1.4rem;
    // padding: 4px;
    border-radius: 3px;
    cursor: pointer;
    position: relative;
    // .inner {
    //   position: absolute;
    //   width: 100%;
    //   top: 50%;
    //   transform: translateY(-50%);
    //   // position: relative;
    //   // top: 50%;
    //   // transform: translateY(-50%);
    // }
  }

  .slider-wrapper {
    $slider_width: 40px;
    $slider_step: -15px;
    $slider_margin: 15px;

    position: relative;
    display: inline-block;
    text-align: center;
    margin: 0 $slider_margin;

    // custom input
    // https://qiita.com/nezurika/items/ea3ae9a3e9ec3c158528
    .input-range[type="range"] {
      -webkit-appearance: none;
      appearance: none;
      background-color: #fff;
      height: 5px;
      // width: 90px;
      vertical-align: 16%;

      &:focus,
      &:active {
        outline: none;
      }

      &::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        cursor: pointer;
        // position: relative;
        border: 2px solid rgba(0, 0, 0, .7);
        width: 8px;
        height: 18px;
        display: block;
        background-color: #fff;
        // border-radius: 50%;
      }

      &:active::-webkit-slider-thumb {
        box-shadow: 0 0 0 4px rgba(255, 255, 255, .6);
        transition: .4s;
      }
    }
    .slider-current-value {
      position: absolute;
      top: $slider_step;
      // bottom: $slider_step;
      width: $slider_width;
      font-size: 14px;
      left: 0;
      right: 0;
      margin: 0 auto;
    }
    .slider-scale {
      position: absolute;
      bottom: $slider_step;
      width: $slider_width;
      font-size: 10px;
      margin: 0 auto;
      &.center {
        left: 0;
        right: 0;
      }
      &.left-end {
        // left: 0;
        left: -$slider_width/2;
        // text-align: right;
      }
      &.right-end {
        // right: 0;
        right: -$slider_width/2;
        // text-align: left;
        // text-align: right;
      }
    }
  }

} //-- container
</style>

<template>
  <div class="input-range_wrapper">
    <div class="mod-button" :style="buttonStyle" @click="onPressDecrement">&laquo;</div>
    <span class="slider-wrapper">
      <input class="input-range" type="range"
        :step="step"
        :min="rangeMin"
        :max="rangeMax"
        :value="value"
        @change="onChangeRange"
      />
      <span class="slider-scale left-end">{{rangeMin}}</span>
      <span class="slider-scale center">0</span>
      <span class="slider-scale right-end">+{{rangeMax}}</span>
      <span class="slider-current-value">{{value}}</span>
    </span>
    <div class="mod-button" :style="buttonStyle" @click="onPressIncrement">&raquo;</div>
  </div>
</template>

<script>
export default {
  name: 'inputRange',
  props: {
    value: Number,
    step: Number,
    rangeMax: Number,
    rangeMin: Number,
    buttonStyle: {
      default () {
        return {
          backgroundColor: "#C1C3C5",
          color: "#4A4E50",
        }
      },
      type: Object,
    }
  },

  data () {
    return {
    }
  },

  methods: {
    onPressDecrement () {
      this.fire(this.value-this.step);
    },
    onPressIncrement () {
      this.fire(this.value+this.step);
    },
    onChangeRange (e) {
      this.fire(Number(e.target.value))
    },
    fire (newVal) {
      this.$emit('change', newVal);
    },
  }
}
</script>




// WEBPACK FOOTER //
// src/components/sub/inputRange.vue